var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('pop-dialog', _vm._g(_vm._b({
    attrs: {
      "height": "auto",
      "width": _vm.isMobile ? '90vw' : '700px'
    }
  }, 'pop-dialog', _vm.$attrs, false), _vm.$listeners), [_c('div', {
    staticClass: "pop-main"
  }, [_c('div', {
    staticClass: "pop-title"
  }, [_vm._v(_vm._s(_vm.$lang("Task")))]), _c('div', {
    staticClass: "taskbox"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("奖项标题")]), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.modifyData.title,
      expression: "modifyData.title"
    }],
    domProps: {
      "value": _vm.modifyData.title
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.modifyData, "title", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("奖项图标")]), _c('div', {
    staticClass: "input file-upload"
  }, [_vm.modifyData.icon ? _c('img', {
    attrs: {
      "src": _vm.modifyData.icon,
      "height": "40px",
      "width": "40px"
    }
  }) : _vm._e(), !_vm.modifyData.icon ? _c('svg-icon', {
    attrs: {
      "name": "upload-filled"
    }
  }) : _vm._e(), _c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onFileChange
    }
  })], 1)]), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("奖励货币")]), _c('div', {
    staticClass: "input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.modifyData.currency,
      expression: "modifyData.currency"
    }],
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.modifyData, "currency", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "TAPCOINS"
    }
  }, [_vm._v(_vm._s(_vm.setting.coin))]), _c('option', {
    attrs: {
      "value": "TAPSTOCK"
    }
  }, [_vm._v("钥匙")]), _c('option', {
    attrs: {
      "value": "TON"
    }
  }, [_vm._v("TON")]), _c('option', {
    attrs: {
      "value": "USDT"
    }
  }, [_vm._v("USDT")]), _c('option', {
    attrs: {
      "value": "GIFT"
    }
  }, [_vm._v("礼品")])])])]), _vm.modifyData.currency != 'GIFT' ? _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("奖励货币金额")]), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.modifyData.amount,
      expression: "modifyData.amount"
    }],
    domProps: {
      "value": _vm.modifyData.amount
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.modifyData, "amount", $event.target.value);
      }
    }
  })])]) : _vm._e(), _vm.modifyData.currency == 'GIFT' ? _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("礼品")]), _c('div', {
    staticClass: "input"
  }, [_c('div', {
    staticClass: "custom-select"
  }, [_c('div', {
    staticClass: "selected-item",
    on: {
      "click": function ($event) {
        _vm.showOptions = !_vm.showOptions;
      }
    }
  }, [!_vm.modifyData.gift_id ? [_c('span', {
    staticClass: "option-text"
  }, [_vm._v("请选择一个礼品")])] : _vm.modifyData.gift_id && _vm.modifyData?.gift_extra && _vm.modifyData?.gift_extra?.gift_thumb ? [_c('img', {
    staticClass: "option-image",
    attrs: {
      "src": _vm.modifyData.gift_extra.gift_thumb,
      "alt": "Selected Image"
    }
  }), _c('span', {
    staticClass: "option-text"
  }, [_vm._v("星星：" + _vm._s(_vm.modifyData.gift_extra.gift_stars) + "， " + _vm._s(_vm.modifyData.gift_extra.gift_type == 0 ? '电报原生' : "" + _vm.modifyData.gift_extra.gift_type == 1 ? '电报NFT' : '其他') + "， 备注：" + _vm._s(_vm.modifyData.gift_extra.remarks))])] : _vm._e()], 2), _vm.showOptions ? _c('div', {
    staticClass: "options-container"
  }, _vm._l(_vm.gift_list, function (item, index) {
    return _c('div', {
      staticClass: "option"
    }, [_c('img', {
      staticClass: "option-image",
      attrs: {
        "src": item.gift_thumb
      }
    }), _c('span', {
      staticClass: "option-text",
      on: {
        "click": function ($event) {
          _vm.modifyData.gift_id = item.id;
          _vm.modifyData.gift_extra = item;
          _vm.showOptions = false;
        }
      }
    }, [_vm._v("星星：" + _vm._s(item.gift_stars) + "， " + _vm._s(item.gift_type == 0 ? '电报原生' : "" + item.gift_type == 1 ? '电报NFT' : '其他') + "， 备注：" + _vm._s(item.remarks))])]);
  }), 0) : _vm._e()])])]) : _vm._e(), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("中奖概率（万几）")]), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.modifyData.winning_rate,
      expression: "modifyData.winning_rate"
    }],
    domProps: {
      "value": _vm.modifyData.winning_rate
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.modifyData, "winning_rate", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("中奖概率（显示）")]), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.modifyData.odds,
      expression: "modifyData.odds"
    }],
    domProps: {
      "value": _vm.modifyData.odds
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.modifyData, "odds", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("每日中奖上限")]), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.modifyData.daily_limit,
      expression: "modifyData.daily_limit"
    }],
    domProps: {
      "value": _vm.modifyData.daily_limit
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.modifyData, "daily_limit", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("显示组合（老虎机）")]), _c('div', {
    staticClass: "input checkbox"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.disp_combo0,
      expression: "disp_combo0"
    }],
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.disp_combo0 = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _c('option', {
    attrs: {
      "value": "CRY"
    }
  }, [_vm._v("没中")]), _c('option', {
    attrs: {
      "value": "USDT"
    }
  }, [_vm._v("USDT")]), _c('option', {
    attrs: {
      "value": "TAP"
    }
  }, [_vm._v("TAP")]), _c('option', {
    attrs: {
      "value": "TON"
    }
  }, [_vm._v("TON")]), _c('option', {
    attrs: {
      "value": "TAPCOINS"
    }
  }, [_vm._v("TAPCOINS")]), _c('option', {
    attrs: {
      "value": "TAPSTOCK"
    }
  }, [_vm._v("TAPSTOCK")])]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.disp_combo1,
      expression: "disp_combo1"
    }],
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.disp_combo1 = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _c('option', {
    attrs: {
      "value": "CRY"
    }
  }, [_vm._v("没中")]), _c('option', {
    attrs: {
      "value": "USDT"
    }
  }, [_vm._v("USDT")]), _c('option', {
    attrs: {
      "value": "TAP"
    }
  }, [_vm._v("TAP")]), _c('option', {
    attrs: {
      "value": "TON"
    }
  }, [_vm._v("TON")]), _c('option', {
    attrs: {
      "value": "TAPCOINS"
    }
  }, [_vm._v("TAPCOINS")]), _c('option', {
    attrs: {
      "value": "TAPSTOCK"
    }
  }, [_vm._v("TAPSTOCK")])]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.disp_combo2,
      expression: "disp_combo2"
    }],
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.disp_combo2 = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _c('option', {
    attrs: {
      "value": "CRY"
    }
  }, [_vm._v("没中")]), _c('option', {
    attrs: {
      "value": "USDT"
    }
  }, [_vm._v("USDT")]), _c('option', {
    attrs: {
      "value": "TAP"
    }
  }, [_vm._v("TAP")]), _c('option', {
    attrs: {
      "value": "TON"
    }
  }, [_vm._v("TON")]), _c('option', {
    attrs: {
      "value": "TAPCOINS"
    }
  }, [_vm._v("TAPCOINS")]), _c('option', {
    attrs: {
      "value": "TAPSTOCK"
    }
  }, [_vm._v("TAPSTOCK")])])])]), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("排序")]), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.modifyData.sort,
      expression: "modifyData.sort"
    }],
    domProps: {
      "value": _vm.modifyData.sort
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.modifyData, "sort", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("状态")]), _c('div', {
    staticClass: "input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.modifyData.status,
      expression: "modifyData.status"
    }],
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.modifyData, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("启用")]), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("禁用")])])])])])]), _c('div', {
    staticClass: "btn",
    style: {
      background: _vm.themeMainColor(_vm.theme).main
    },
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v(_vm._s(_vm.$lang("Submit")))])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };